/**
 * 管理所有弹窗的显示/隐藏状态
 */
import { createModel } from "@rematch/core";
import { RootModel } from ".";
interface ModalState {
  /** ConnectWallet */
  connectWallet: boolean;

  /** Mint */
  mint: boolean;

  /** cancelConnectWallet */
  cancelConnectWallet: boolean;

  /** cancelConnectWallet */
  gameResult: {
    open: boolean;
    status?: 0 | 1 | 2;
    isGift?: boolean;
    errorMsg?: string;
  };
}

const initialState: ModalState = {
  connectWallet: false,
  mint: false,
  cancelConnectWallet: false,
  gameResult: {
    open: false,
    status: 0,
  },
};

export const modal = createModel<RootModel>()({
  state: initialState,
  reducers: {
    setFields(state, fields: Partial<ModalState>): ModalState {
      return {
        ...state,
        ...fields,
      };
    },
    openModal(state: ModalState, name: keyof ModalState) {
      return {
        ...state,
        [name]: true,
      };
    },
    closeModal() {
      return {
        ...initialState,
      };
    },
  },
  effects: () => ({}),
});
